<template lang="pug">
#lista-monitoramento-agricola
    .reorganizarMapaTabela
        | {{ $t('mensagens.monitoramentoAgricola.reorganizarMapaTabela') }}
        span.reorganizarMapaTabela--reorganizar-icon(
            @click='organizarLayout',
            :class='[larguraTotal ? "rotate" : ""]'
        )
            i.lyra-icon.lyra-pontos

    .lista-monitoramento-agricola__container(
        :class='[larguraTotal ? "isOrganizarWidth" : ""]',
        v-loading='carregando'
    )
        .territorio-monitoramento-tabela
            h3 {{ $t('mensagens.monitoramentoAgricola.listagemTerritoriosMonitorados') }}
            .tabela
                TabelaMonitoramentoAgricola(
                    v-if='paginaAreasMonitoradas !== {}',
                    :paginaAreasMonitoradas='paginaAreasMonitoradas',
                    :paginacao='paginacao',
                    :larguraTotal='larguraTotal',
                    :key='keyLista',
                    @ordenar='ordenar',
                    @mudarPagina='mudarPagina',
                    @salvarFiltro='salvarFiltroMonitoramento'
                )

        .territorio-monitoramento-mapa
            mapa(
                height='100%',
                idMapa='MapaListagemMonitoramentoAgricola',
                :key='keyMapa',
                :mapLayersConfigs='camadasMapa',
                :mapConfig='configuracoesMapa',
                :camadaCentralizadaNome='camadaCentralizadaNome'
            )
</template>

<script>
import L from 'leaflet';
import Mapa from '@/components/MapaLeaflet';
import TabelaMonitoramentoAgricola from '@/components/monitoramento/TabelaMonitoramentoAgricola';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import constantes from '@/utils/constantes';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'ListaMonitoramentoAgricola',

    components: {
        Mapa,
        TabelaMonitoramentoAgricola
    },

    props: {
        filtros: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    ferramentasControl: false
                },
                inspecionar: true,
                diagnostico: true
            },
            larguraTotal: false,
            keyMapa: 1,
            keyLista: 10,
            paginaAreasMonitoradas: {
                itens: []
            },
            paginacao: {
                tamanho: constantes.TAMANHO_PAGINA,
                pagina: 0,
                ordenacao: 'territorio'
            },
            camadaCentralizadaNome: null,
            carregando: true
        };
    },

    watch: {
        filtros() {
            this.paginacao.pagina = 0;
            this.filtrarAreasMonitoradas();
        }
    },

    async created() {
        await this.filtrarAreasMonitoradas();
    },

    mounted() {
        this.handleVisualizarMonitoramento = (event) => {
            const { territorioId } = event.detail;
            this.navegarParaMonitoramento(territorioId);
        };
        window.addEventListener('visualizarMonitoramento', this.handleVisualizarMonitoramento);
    },

    beforeDestroy() {
        if (this.handleVisualizarMonitoramento) {
            window.removeEventListener('visualizarMonitoramento', this.handleVisualizarMonitoramento);
        }
    },

    computed: {
        ...mapGetters(['filtroMonitoramento'])
    },

    methods: {
        ...mapActions(['setfiltroMonitoramento']),
        organizarLayout: function () {
            this.keyMapa++;
            this.larguraTotal = !this.larguraTotal;
        },

        async filtrarAreasMonitoradas() {
            try {
                this.carregando = true;
                const { data } =
                    await MonitoramentoAgricolaService.buscarAreasMonitoradas(
                        this.filtros,
                        this.paginacao
                    );
                this.paginaAreasMonitoradas = data;
                this.atualizarMapa();
                this.carregando = false;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.filtrarAreasMonitoradas'
                    )
                });
            }
        },

        salvarFiltroMonitoramento() {
            this.setfiltroMonitoramento(this.filtros);
        },

        ordenar(ordenacao) {
            this.paginacao.ordenacao = ordenacao;
            this.filtrarAreasMonitoradas();
        },

        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.filtrarAreasMonitoradas();
            this.$emit('buscarTotalizadores');
        },

        navegarParaMonitoramento(territorioId) {
            this.$router.push({
                name: 'MonitoramentoAgricolaImovel',
                params: { id: territorioId }
            });
        },

        atualizarMapa() {
            this.camadasMapa = [];

            this.paginaAreasMonitoradas.itens.forEach(({ id, territorio }) => {
                this.camadasMapa.push({
                    name: 'areaMonitorada_' + id,
                    geoJson: territorio.centroide,
                    icon: L.icon({
                        iconUrl:
                            'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
                        iconSize: [18, 26]
                    }),
                    popup: this.criarPopup({ ...territorio, id }),
                    acaoClick: () => this.mostrarDetalhesTerritorio(territorio)
                });
            });
        },

        mostrarDetalhesTerritorio({ id, geometria }) {
            const exibindoTerritorio = !!this.camadasMapa.find(
                ({ name }) => name === 'territorioExibido' + id
            );
            if (!exibindoTerritorio) {
                this.camadasMapa.push({
                    name: 'territorioExibido' + id,
                    geoJson: geometria,
                    style: getEstiloGeometria('area')
                });
            }

            this.camadaCentralizadaNome = 'territorioExibido' + id;
        },

        criarPopup({ id, nome, localidade }) {
            return `
				<h3>Território:</h3>
				<h4>${nome}</h4>
				<br>
				<h3>Localidade:</h3>
				<h4>${localidade || '--'}</h4>
				<br>
				<br>
				<div class="btn-realizar-diagnostico" onclick="window.dispatchEvent(new CustomEvent('visualizarMonitoramento', { detail: { territorioId: ${id} } }))">
					<span>Visualizar monitoramento</span>
				</div>
			`;
        }
    }
};
</script>

<style lang="scss" scoped>
#lista-monitoramento-agricola {
    .reorganizarMapaTabela {
        font-size: 16px;
        margin-bottom: 16px;
        font-weight: 500;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .reorganizarMapaTabela--reorganizar-icon {
            padding: 10px;
            padding-bottom: 3px;
            background: var(--white);
            box-shadow: 0px 1px 7px 0px var(--block-shadow);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            cursor: pointer;

            i::before {
                width: 7px !important;
                height: 23px !important;
                background: #3b3b3b;
            }
            &.rotate {
                i::before {
                    transform: rotate(90deg);
                }
            }
        }
    }
    .lista-monitoramento-agricola__container {
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        .territorio-monitoramento-tabela {
            width: 59%;

            .tabela {
                padding-top: 0px;
                padding-bottom: 10px;
                margin-right: 10px;
                width: calc(100% - 10px);
            }
        }
        .territorio-monitoramento-mapa {
            width: 41%;
            height: 633px;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 1px 5px 0px var(--block-shadow);
            margin-bottom: 14px;
            #mapa-listagem-territorio {
                border-radius: 6px;
            }
        }

        &.isOrganizarWidth {
            .territorio-monitoramento-tabela,
            .territorio-monitoramento-mapa {
                width: 100% !important;
            }
            .territorio-monitoramento-mapa {
                order: 1;
            }
            .territorio-monitoramento-tabela {
                order: 2;
                h3 {
                    margin-top: 12px !important;
                }
                .tabela {
                    margin-right: 0px !important;
                }
            }
        }
    }
    h3 {
        margin-bottom: 10px;
        margin-top: -30px;
        color: var(--var(--black));
        font-weight: 500;
    }
    .dimensao-mapa {
        height: 100% !important;
    }
}
</style>
